var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'form-inline': _vm.inline }},_vm._l((_vm.computedOptions),function(ref,key){
var value = ref.value;
var label = ref.label;
var props = ref.props;
return _c('CInputRadio',_vm._b({key:key,attrs:{"label":label,"name":_vm.groupName,"value":value,"checked":_vm.checked === value,"custom":_vm.custom,"inline":_vm.inline},on:{"change":function($event){return _vm.change($event, value)}}},'CInputRadio',props,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }